var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',[_vm._v("  "+_vm._s(this.$t('privacy_policy'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }